






































































import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { IssueCommentEntity } from '@/entities/issue-comment.entity';
import ReactionItem from '@/components/ViewComponent/Issue/Reaction/ReactionItem.vue';
import AddReactionButton from '@/components/ViewComponent/Issue/Reaction/AddReactionButton.vue';
import { service } from '@/services/service';
import IssueCommentReactionService from '@/services/issue-comment-reaction.service';
import { saveAs } from 'file-saver';
import UserAvatar from '@/components/Helper/UserAvatar.vue';
import EditIssueComment from '@/components/ViewComponent/Issue/EditIssueComment.vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<IssueCommentItem>({
  components: {
    EditIssueComment,
    UserAvatar,
    AddReactionButton,
    ReactionItem,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class IssueCommentItem extends Vue {
  currentStaff!: StaffEntity;
  @Prop({ type: Object as PropType<IssueCommentEntity> })
  comment: IssueCommentEntity;

  @Prop({ type: Boolean })
  odd: boolean;

  @Prop({ type: Boolean })
  first: boolean;

  @Prop({ type: Boolean })
  last: boolean;

  isShow = false;

  showModal() {
    if (this.currentStaff.id !== this.comment.commenterId) return;
    this.isShow = true;
  }

  // eslint-disable-next-line class-methods-use-this
  get reactionService() {
    return service(IssueCommentReactionService);
  }

  get color() {
    return this.odd ? 'white' : 'grey lighten-4';
  }

  get rounded() {
    if (this.first) {
      return 't';
    }
    if (this.last) {
      return 'b';
    }
    return null;
  }
  download = saveAs;
}
